<template>
  <div class="light-gray">
    <component @reDrawMemoImage="reDrawMemoImage" @emitReload="emitReload" :is="header"></component>
    <slot></slot>
    <component :is="footer"></component>
  </div>
</template>
<script>
import ControlHeader from '@/components/AdjustmentHeader.vue'
import ControlFooter from '@/components/AdjustmentFooter.vue'

export default {
  name: 'AdjustmentCommonLayout',
  props: ['header', 'footer'],
  components: {
    controlHeader: ControlHeader,
    controlFooter: ControlFooter
  },
  data () {
    return {
      userBrowser: ''
    }
  },
  methods: {
  },
  mounted: function () {
    if (process.env.APP_ENV !== 'production') {
      document.title = '【テスト環境】' + this.config.projectName
    }
  },
  created () {
  },
  destroyed () {
  }
}
</script>



// WEBPACK FOOTER //
// src/layout/AdjustmentCommonLayout.vue